<template>
  <section>
    <ProjectsSingleHeader />
    <ProjectsSingleIntro />
    <ProjectsSingleContent />
    <ProjectsSingleMore v-if="project" />
  </section>
</template>

<script>
import * as partials from './partials'

export default {
  name: 'ProjectsSingle',
  components: { ...partials },
  props: {
    projectSlug: String
  },
  provide() {
    return { wp: this.project }
  },
  computed: {
    project() {
      return this.$wp.projects[this.projectSlug] || {}
    }
  },
  mounted() {
    console.log('project', this.project)
  }
}
</script>
